// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 175) return "static/chunks/175-f0b800b769a96188.js";
	if (chunkId === 850) return "static/chunks/850-6886274a4de7f73c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"306":"af4b5780bcf09800","841":"bff8d1f5b6395e47"}[chunkId] + ".js";
};